<template>
    <div>
        
        <div v-if="custom_list.length>0">
            <common-list  :pageurl="this.$api_url"  :is_pf="is_n_pf"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
        </div>
        <div v-else>

            <div v-if="show_loader" class="list-no-data">
                <span class="d-block text-center">Looking for relevant data..</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
            <div v-else class="list-no-data">
                Looks like there is no employee to show.
            </div>
            
        </div>

        <pf-settlement-form-quick-view :pageurl="pageurl" :settlement_id="settlement_id" :employee_id="employee_id"  :employee_name="employee_name" :quick_view="quick_view" :action_type="action_type" :key="settle_form_key" ></pf-settlement-form-quick-view>

    </div> 
</template>
<script>
    export default{
        
        mounted() {
            
            this.showoverlay = false;
        }, 
        props: ['flg','pageurl','is_action'],
        components: {
     
        },
        data(){            

            return {
                custom_list:[],  /* Data List */
                default_column:['name','employee_code'],    /* Default Column List */
                appended_column:[
                     
                    { value: "settlement_company_code", text: "Settlement ID",type: "text"},
                    { value: "settlement_type", text: "Settlement Type",type: "text"},
                    { value: "settlement_date", text: "Settlement Date",type: "date"},
                    // { value: "settlement_amount", text: "Settlement Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "settlement_amount", text: "Settlement Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "application_status", text: "Status",type: "text"},
                
                ],                   /* Appended Column List  and there title and type */
                primary_key:'settlement_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */
                list_key:0,
                is_n_pf:1,
                show_loader:false,
                settlement_id:0,
                settle_form_key:0,
                employee_id:0,
                employee_name:0,
                show_approval:0,
                quick_view :0,
                action_type:"",


            }
        },
        methods:{
            listReturn:function(data)
            {
                
                if(data.action_id==1)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id); 
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 1;
                        this.action_type = "";
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.settle_form_key += 1;
                    }
                    console.log(data);
                }
                if(data.action_id==2)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id);
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 0;
                        this.action_type = "resubmit";
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.settle_form_key += 1;
                    }
                    console.log(data);
                }    
            },
            getSettlementList: function()
            {

                this.show_loader = true;
                let currentObj = this;                    
                let formData = new FormData();
                if(!this.checkNet()) return false;
                formData.append('list_type', 'deferred_settlement');
                axios.post(this.$api_url+'/pf/settlement/list', formData)
                .then(function (response) 
                {
                     
                    let temp_settle_list;
                    /* Assingning the Options */  

                    currentObj.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */ 
                    temp_settle_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    console.log(temp_settle_list); 
                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    
                    if(temp_settle_list.length > 0 )
                    {

                         
                        temp_settle_list.forEach(element => {
                            let dop = []; 
                            dop = dop.concat([{ label: 'Quick View' , value: 1 }]);
                            dop = dop.concat([{ label: 'Re Submit' , value: 2 }]);
                            element.actions = dop; 
                            }); 
 
                          
                        
                    }
                    else
                    {
                        currentObj.blankmsg = "No employee found as leaver";
                    }
                    
                    currentObj.custom_list = temp_settle_list;
                    currentObj.list_key = currentObj.list_key + 1;
                    currentObj.show_loader = false;                       
                   
                    
                }.bind(this))
                .catch(function (error) 
                {
                    console.log(error);
                    currentObj.show_loader = false;
                });
                
            },
            overviewReturn:function()
            {
                this.$validator.reset();
                this.getSettlementList();
            },
        },
        created: function(){
            this.getSettlementList();
        },
        computed: 
        {
            
        }
    }
</script>